export function getPath<TRes>(obj: Record<PropertyKey, TRes | unknown>, path: string): TRes | undefined {
    const [prop, ...rest] = path.split(".");
    const sub = obj[prop];
    if (sub && typeof sub === "object" && rest.length) {
        return getPath(sub as Record<PropertyKey, TRes>, rest.join("."));
    } else {
        return sub as TRes | undefined;
    }
}

export function stripPropertiesRecursive(obj: Record<string, unknown>, properties: string[]) {
    for (const [key, value] of Object.entries(obj)) {
        if (properties.includes(key)) {
            delete obj[key];
            continue;
        }
        if (value && typeof value === "object" && !Array.isArray(value)) {
            stripPropertiesRecursive(value as Record<string, unknown>, properties);
        }
    }
    return obj;
}
